import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "content",
    "icon"
  ]

  toggle(e) {
    if (this.expanding) {
      this.contentTarget.style.display = "none";
    } else {
      this.contentTarget.style.display = "";
    }

    this.expanding = !this.expanding;
    this.setIcon();
  }

  setIcon() {
    while (this.iconTarget.firstChild) {
      this.iconTarget.removeChild(this.iconTarget.firstChild);
    }
    const i = document.createElement("i");
    i.classList.add("fas");

    if (this.expanding) {
      i.classList.add("fa-angle-up");
    } else {
      i.classList.add("fa-angle-down");
    }
    this.iconTarget.append(i);
  }

  connect() {
    this.expanding = this.contentTarget.style.display !== "none";
    this.setIcon();
  }
}
